var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"mt-5 pt-5 text-muted text-center text-small"},[_c('p',{staticClass:"mb-0"},[_c('Copyright',{staticClass:"text-white text-truncate"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }